import {
  FETCH_CATEGORIES_REQUEST,
  FETCH_CATEGORIES_SUCCESS,
  FETCH_CATEGORIES_FAILURE,
  FETCH_SUBCATEGORIES_REQUEST,
  FETCH_SUBCATEGORIES_SUCCESS,
  FETCH_SUBCATEGORIES_FAILURE,
  FETCH_ALL_SUBCATEGORIES_REQUEST,
  FETCH_ALL_SUBCATEGORIES_SUCCESS,
  FETCH_ALL_SUBCATEGORIES_FAILURE,
  FETCH_USES_REQUEST,
  FETCH_USES_SUCCESS,
  FETCH_USES_FAILURE,
  FETCH_MATERIALITIES_REQUEST,
  FETCH_MATERIALITIES_SUCCESS,
  FETCH_MATERIALITIES_FAILURE,
  FETCH_FILE_TAGS_REQUEST,
  FETCH_FILE_TAGS_SUCCESS,
  FETCH_FILE_TAGS_FAILURE,
  SET_SELECTED_TYPE,
  SET_SELECTED_CATEGORY,
  SET_SELECTED_SUBCATEGORY,
  SET_SELECTED_USES,
  SET_SELECTED_MATERIALITIES,
  SET_FORM_DATA,
  REPLACE_FORM_DATA,
  RESET_FORM,
  SET_SHOW_HEADER_SUMMARY,
  SET_CREATION_PROGRESS_MODAL,
  UPDATE_CREATION_PROGRESS,
  CREATE_PROJECT_DOCUMENTATION_REQUEST,
  CREATE_PROJECT_DOCUMENTATION_SUCCESS,
  CREATE_PROJECT_DOCUMENTATION_FAILURE,
  UPDATE_PROJECT_DOCUMENTATION_REQUEST,
  UPDATE_PROJECT_DOCUMENTATION_SUCCESS,
  UPDATE_PROJECT_DOCUMENTATION_FAILURE,
  FETCH_PROJECT_DOCUMENTATION_REQUEST,
  FETCH_PROJECT_DOCUMENTATION_SUCCESS,
  FETCH_PROJECT_DOCUMENTATION_FAILURE,
  FETCH_USER_PROJECT_DOCUMENTATIONS_REQUEST,
  FETCH_USER_PROJECT_DOCUMENTATIONS_SUCCESS,
  FETCH_USER_PROJECT_DOCUMENTATIONS_FAILURE,
  DELETE_PROJECT_DOCUMENTATION_REQUEST,
  DELETE_PROJECT_DOCUMENTATION_SUCCESS,
  DELETE_PROJECT_DOCUMENTATION_FAILURE
} from '../actions/projectDocumentationActions';
import { DEFAULT_FORM_VALUES } from '../../constants/projectDocumentation.ts';

const initialState = {
  categories: [],
  subCategories: [],
  allSubCategories: {}, 
  uses: [],
  materialities: [],
  fileTags: [],
  selectedType: null,
  selectedCategory: null,
  selectedSubCategory: null,
  selectedUses: [],
  selectedMaterialities: [],
  formData: DEFAULT_FORM_VALUES,
  loading: false,
  error: null,
  currentProjectDocumentation: null,
  createLoading: false,
  updateLoading: false,
  fetchLoading: false,
  showHeaderSummary: false,
  userDocumentations: [],
  userDocumentationsLoading: false,
  lastFetchedUserId: null,
  deleteLoading: false,
  creationProgressModal: {
    isOpen: false,
    state: 'creating',
    message: '',
    progress: null
  }
};

const projectDocumentationReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CATEGORIES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_CATEGORIES_SUCCESS:
      return {
        ...state,
        categories: action.payload,
        loading: false,
        error: null
      };
    case FETCH_CATEGORIES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case FETCH_SUBCATEGORIES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_SUBCATEGORIES_SUCCESS:
      return {
        ...state,
        subCategories: action.payload,
        loading: false,
        error: null
      };
    case FETCH_SUBCATEGORIES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case FETCH_ALL_SUBCATEGORIES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_ALL_SUBCATEGORIES_SUCCESS:
      return {
        ...state,
        allSubCategories: action.payload,
        loading: false,
        error: null
      };
    case FETCH_ALL_SUBCATEGORIES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case FETCH_USES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_USES_SUCCESS:
      return {
        ...state,
        uses: action.payload,
        loading: false,
        error: null
      };
    case FETCH_USES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case FETCH_MATERIALITIES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_MATERIALITIES_SUCCESS:
      return {
        ...state,
        materialities: action.payload,
        loading: false,
        error: null
      };
    case FETCH_MATERIALITIES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case FETCH_FILE_TAGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_FILE_TAGS_SUCCESS:
      return {
        ...state,
        fileTags: action.payload,
        loading: false,
        error: null
      };
    case FETCH_FILE_TAGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case SET_SELECTED_TYPE:
      return {
        ...state,
        selectedType: action.payload
      };
    case SET_SELECTED_CATEGORY:
      return {
        ...state,
        selectedCategory: action.payload,
        selectedSubCategory: null, 
        subCategories: [] 
      };
    case SET_SELECTED_SUBCATEGORY:
      return {
        ...state,
        selectedSubCategory: action.payload
      };
    case SET_SELECTED_USES:
      return {
        ...state,
        selectedUses: action.payload
      };
    case SET_SELECTED_MATERIALITIES:
      return {
        ...state,
        selectedMaterialities: action.payload
      };

    case SET_FORM_DATA:
      return {
        ...state,
        formData: { ...state.formData, ...action.payload }
      };
    case REPLACE_FORM_DATA:
      return {
        ...state,
        formData: action.payload
      };
    case RESET_FORM:
      return {
        ...state,
        formData: initialState.formData,
        selectedType: null,
        selectedCategory: null,
        selectedSubCategory: null,
        selectedUses: [],
        selectedMaterialities: [],
        subCategories: [],
        fileTags: state.fileTags,
        showHeaderSummary: false
      };
    case SET_SHOW_HEADER_SUMMARY:
      return {
        ...state,
        showHeaderSummary: action.payload
      };
    case SET_CREATION_PROGRESS_MODAL:
      return {
        ...state,
        creationProgressModal: action.payload
      };
    case UPDATE_CREATION_PROGRESS:
      return {
        ...state,
        creationProgressModal: {
          ...state.creationProgressModal,
          ...action.payload
        }
      };
    case CREATE_PROJECT_DOCUMENTATION_REQUEST:
      return {
        ...state,
        createLoading: true,
        error: null
      };
    case CREATE_PROJECT_DOCUMENTATION_SUCCESS:
      return {
        ...state,
        createLoading: false,
        error: null,
        lastFetchedUserId: null
      };
    case CREATE_PROJECT_DOCUMENTATION_FAILURE:
      return {
        ...state,
        createLoading: false,
        error: action.payload
      };

    case UPDATE_PROJECT_DOCUMENTATION_REQUEST:
      return {
        ...state,
        updateLoading: true,
        error: null
      };
    case UPDATE_PROJECT_DOCUMENTATION_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        error: null,
        lastFetchedUserId: null
      };
    case UPDATE_PROJECT_DOCUMENTATION_FAILURE:
      return {
        ...state,
        updateLoading: false,
        error: action.payload
      };

    case FETCH_PROJECT_DOCUMENTATION_REQUEST:
      return {
        ...state,
        fetchLoading: true,
        error: null
      };
    case FETCH_PROJECT_DOCUMENTATION_SUCCESS:
      return {
        ...state,
        currentProjectDocumentation: action.payload,
        fetchLoading: false,
        error: null
      };
    case FETCH_PROJECT_DOCUMENTATION_FAILURE:
      return {
        ...state,
        fetchLoading: false,
        error: action.payload
      };

    case FETCH_USER_PROJECT_DOCUMENTATIONS_REQUEST:
      return {
        ...state,
        userDocumentationsLoading: true,
        error: null
      };
    case FETCH_USER_PROJECT_DOCUMENTATIONS_SUCCESS:
      const payload = action.payload;
      const documentations = payload?.documentations || payload || [];
      const fetchedUserId = payload?.userId || null;
      return {
        ...state,
        userDocumentations: Array.isArray(documentations) ? documentations : [],
        lastFetchedUserId: fetchedUserId,
        userDocumentationsLoading: false,
        error: null
      };
    case FETCH_USER_PROJECT_DOCUMENTATIONS_FAILURE:
      return {
        ...state,
        userDocumentationsLoading: false,
        error: action.payload
      };

    case DELETE_PROJECT_DOCUMENTATION_REQUEST:
      return {
        ...state,
        deleteLoading: true,
        error: null
      };
    case DELETE_PROJECT_DOCUMENTATION_SUCCESS:
      return {
        ...state,
        userDocumentations: state.userDocumentations.filter(doc => {
          const docId = typeof doc.id === 'string' ? parseInt(doc.id) : doc.id;
          const payloadId = typeof action.payload === 'string' ? parseInt(action.payload) : action.payload;
          return docId !== payloadId;
        }),
        deleteLoading: false,
        error: null
      };
    case DELETE_PROJECT_DOCUMENTATION_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        error: action.payload
      };

    default:
      return state;
  }
};

export default projectDocumentationReducer;

